// Docker images are built with placeholders such as __REACT_APP_ENCRYPTION_KEY__
// that inject-runtime-env.sh replaces when the container starts. A placeholder
// still in the bundle means that step never ran, so treat the value as unset.
// Only the prefix is written here: a full placeholder would be replaced too.
export const configuredEnv = (value?: string): string | undefined =>
  value && !value.startsWith('__REACT_APP_') ? value : undefined
